<script setup>
    import __ from '@components/../mixins/locale'
    import axios from 'axios'
    import UserRelationships from '@components/UserRelationships.vue'
    import { onMounted, reactive, ref } from 'vue'
    import paginate from 'vuejs-paginate-next'

    const props = defineProps({
        type: {
            type: String,
            required: false,
            default () {
                return 'friends'
            },
        },
        profileUserId: {
            type: Number,
            required: true
        },
        userRoute: {
            type: String,
            required: true
        },
        isOwner: {
            type: Boolean,
            required: false,
            default () {
                return false
            },
        },
        apiToken: {
            type: String,
            default () {
                return null
            },
            required: false
        }
    });

    const currentList = ref([]);

    const pagination = reactive({
        pageCount: 1,
        pageRange: 1,
        marginPages: 1,
        currentPage: 1,
    });

    const loading = ref(true);

    const currentSection = ref(props.type);

    const changeSection = section => {
        currentSection.value = section;
        getRelationships(section);
    }

    const getRelationships = typeState => {
        loading.value = true;
        axios.get('/api/user-relationships', {
            params: {
                'profile_user_id': props.profileUserId,
                'relationship_type': 'FRIEND',
                'type_state': typeState,
                'page': pagination.currentPage
            }
        }).then(response => {
            if (response.data) {
                currentList.value = response.data.data;
                pagination.pageCount = response.data.last_page;
            }
            loading.value = false;
        });
    }

    const paginateAction = page => {
        pagination.currentPage = page;
        getRelationships(currentSection.value);
    }

    const removeFromList = index => {
        currentList.value.splice(index, 1);
    }

    onMounted(() => {
        getRelationships(currentSection.value);
    });
</script>

<template>
    <div v-if="currentList" class="container" :class="currentSection === 'requests' ? 'card' : ''" :style="currentSection === 'requests' ? 'background-color: #343a40' : ''">
        <div v-if="loading">
            <div class="loading-indicator"><div></div><div></div><div></div></div>
        </div>
        <template v-else>
        <paginate
            v-if="pagination.pageCount > 1"
            :model-value="pagination.currentPage"
            :page-count="pagination.pageCount"
            :page-range="pagination.pageRange"
            :margin-pages="pagination.marginPages"
            :click-handler="paginateAction"
            prev-text="Prev"
            next-text="Next"
            container-class="pagination my-4"
            prev-class="page-item"
            prev-link-class="page-link"
            next-class="page-item"
            next-link-class="page-link"
            page-link-class="page-link"
            page-class="page-item">
        </paginate>

        <div class="row">
            <div class="col-6 col-md-4 col-lg-3 my-2 px-2" v-for="(currentListItem, index) in currentList">
                <div class="card">
                    <div class="card-body" style="text-align: center;">
                        <h5 class="card-title" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 180px; margin: 0 auto; height: 30px;">
                            <span v-if="currentListItem.genderIcon" v-html="currentListItem.genderIcon"></span>
                            <strong>{{ currentListItem.username }}</strong>
                            {{ currentListItem.age ? '(' + currentListItem.age + ')' : '' }}
                        </h5>
                        <div v-if="currentListItem.has_avatar" style="width: 100px; height: 100px; text-align: center; margin: 10px auto;">
                            <div class="img-thumbnail" :style="'width: 100%; height: 100%; background-size: cover; background-color: #f9f9f9; background-position: center; background-repeat: no-repeat; background-image: url(\'/storage' + currentListItem.avatar.thumbnail.src + '\')'"></div>
                        </div>
                        <p style="overflow: hidden; text-overflow: ellipsis; max-width: 180px; margin: 10px auto; height: 70px;"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="map-marker-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="width: .8rem; margin-bottom: 3px; color: #dc3545;"><path fill="currentColor" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path></svg> {{ currentListItem.formattedAddress }}</p>
                        <UserRelationships v-if="apiToken && currentSection != 'friends' && isOwner" :user-id="profileUserId" :relationship-user-id="currentListItem.id" type="FRIEND" :api-token="apiToken" @removeItem="removeFromList(index)" />
                        <a :href="userRoute + '/' + currentListItem.username" class="btn btn-primary" :class="currentSection === 'friends' ? 'stretched-link' : ''" style="margin-top: 10px; display: block;">{{ __('View Profile') }}</a>
                    </div>
                </div>
            </div>
        </div>
        <paginate
            v-if="pagination.pageCount > 1"
            :model-value="pagination.currentPage"
            :page-count="pagination.pageCount"
            :page-range="pagination.pageRange"
            :margin-pages="pagination.marginPages"
            :click-handler="paginateAction"
            prev-text="Prev"
            next-text="Next"
            container-class="pagination my-4"
            prev-class="page-item"
            prev-link-class="page-link"
            next-class="page-item"
            next-link-class="page-link"
            page-link-class="page-link"
            page-class="page-item">
        </paginate>
        </template>
    </div>
</template>